module.exports = __webpack_public_path__ + "static/media/1012825.9cddc231.png";